import { useQuery } from "@apollo/react-hooks";

import { LearnerLessonDetails } from "../types";
import learnerLessonDetailsQuery from "../graph-ql/learnerLessonDetails.graphql";

const useLearnerLessonDetails = (id?: string, instructorId?: string) =>
  useQuery<{ learner: LearnerLessonDetails }>(learnerLessonDetailsQuery, {
    variables: {
      id,
      instructorId,
    },
    skip: !id,
  });

export default useLearnerLessonDetails;
